import React, { Component } from "react";
import moment, { isDate } from "moment";

import { getSmallest, getPriceRank, getSearchUrl, getIntentByDate } from "./Main";
import { addDecimalPoints, getClassNames } from "../../shared/utils";

const winWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);

const getMonthLength = yearMonth => {
	const [year, month] = yearMonth.split("-");
	return new Date(year, month, 0).getDate();
};

const getStartWeekDay = yearMonth => {
	const [year, month] = yearMonth.split("-");
	const weekDay = moment(`${year}-${month}-01`).day();
	return weekDay;
};

const isDateBetweenRange = (startDate, endDate, dateToBeChecked) => {
	if (!startDate && !endDate && !dateToBeChecked) return null;

	const start = moment(startDate);
	const end = moment(endDate);
	const date = moment(dateToBeChecked);

	if (date.diff(start) === 0) return "start";
	else if (date.diff(end) === 0) return "end";
	else if (date.diff(start) > 0 && date.diff(end) < 0) return "middle";
	else return false;
};

const ANIMATION_DURATION = 0.3;

class Day extends Component {
	constructor(props) {
		super(props);

		this.state = { tooltip: false };

		this.setIntent = this.setIntent.bind(this);
		this.setTooltip = this.setTooltip.bind(this);
		this.renderTooltip = this.renderTooltip.bind(this);
		this.renderPrice = this.renderPrice.bind(this);
		this.setAnimationState = this.setAnimationState.bind(this);
		this.tooltipTimeout = null;
	}

	setIntent() {
		const {
			setGoIntent,
			setBackIntent,
			goIntent,
			backIntent,
			tripType,
			date,
			getPriceCalendar
		} = this.props;

		if (tripType == "OW") {
			setGoIntent(date);
		} else {
			const currentDate = moment(date);
			const goDate = moment(goIntent);

			const forComing = currentDate.diff(goDate) > 0;
			const sameIntent = currentDate.diff(goDate) === 0;
			const setGoIntentAndRefresh = date => {
				setGoIntent(date);
				setTimeout(() => getPriceCalendar(this.props), 0); //gambi
			};

			if (!goIntent) setGoIntentAndRefresh(date);
			else {
				if (goIntent && backIntent) setGoIntentAndRefresh(date);
				else if (sameIntent) setBackIntent(date);
				else if (!forComing) setGoIntentAndRefresh(date);
				else setBackIntent(date);
			}
		}
	}

	setTooltip(msg) {
		if (!msg) this.setState({ tooltip: false });
		else {
			this.setState({ tooltip: msg });
			this.tooltipTimeout = setTimeout(() => this.setTooltip(false), 3000);
		}
	}

	renderTooltip() {
		const { tooltip } = this.state;

		if (!tooltip) return null;

		const onClick = e => {
			e.stopPropagation();
			this.setTooltip(false);
		};

		return (
			<div onClick={onClick} className="big-calendar__tooltip">
				<span>{tooltip}</span>
			</div>
		);
	}

	renderPrice(price, disabled) {
		if (disabled) return null;
		else if (!price && this.props.tripType == "RT") return null;
		else if (!price) return <div className="circle-question">?</div>;

		let value = parseInt(price);

		return (
			<div>
				<span className="currency">R$</span>
				<span className="value">{addDecimalPoints(value)}</span>
			</div>
		);
	}

	setAnimationState(animationFinished) {
		return this.setState({ animationFinished });
	}

	render() {
		const {
			date,
			monthIndex,
			monthLength,
			priceRange,
			backIntent,
			goIntent,
			searchIntents,
			tripType
		} = this.props;

		// Datas
		const dateData =
			tripType === "RT"
				? getIntentByDate(date, searchIntents, true)
				: getIntentByDate(date, searchIntents);
		const goData = getIntentByDate(goIntent, searchIntents);
		const backAndForthData = getIntentByDate(backIntent, searchIntents, true);
		const currentLeg = !goIntent || tripType === "OW" ? "out" : "in";

		// Day info
		const today = moment(moment().format("YYYY-MM-DD"));
		const dateIsPast = today.diff(moment(date), "days") > 0;
		const dateIsToday = today.diff(moment(date), "days") == 0;
		const dateIsFuture = !dateIsToday && !dateIsPast;
		let disabled = !dateIsFuture;
		const dateIsInRange = isDateBetweenRange(goIntent, backIntent, date);
		const dateIsSelected = goIntent === date || backIntent === date;
		const dateIsBeforeGoDate =
			tripType === "RT" &&
			dateIsFuture &&
			(goIntent && moment(goIntent).diff(moment(date), "days") > 0);

		// Animation
		const delayMultiplier =
			dateIsInRange === "middle" && moment(date).diff(moment(goIntent), "days");
		const delayFraction = dateIsInRange
			? ANIMATION_DURATION / moment(backIntent).diff(moment(goIntent), "days")
			: null;
		const animationDelay =
			delayMultiplier && delayFraction ? delayMultiplier * delayFraction : null;
		if (animationDelay)
			setTimeout(() => this.node.classList.add("animation-finished"), animationDelay * 1000);
		const style = animationDelay ? { transitionDelay: `${animationDelay}s` } : {};

		// Price
		let irrelevant = dateIsBeforeGoDate;
		let price =
			tripType == "RT"
				? getSmallest(dateData, { withTaxes: true, leg: "in" }) +
				  getSmallest(dateData, { withTaxes: true, leg: "out" })
				: getSmallest(dateData);
		if (tripType === "RT" && (!goIntent || backIntent)) {
			irrelevant = true;
		}
		if (dateIsSelected) {
			irrelevant = false;
			if (searchIntents && tripType === "RT") {
				const goPrice = backAndForthData
					? getSmallest(backAndForthData, { withTaxes: true, leg: "out" })
					: null;
				const backPrice = backAndForthData
					? getSmallest(backAndForthData, { withTaxes: true, leg: "in" })
					: null;

				if (!backIntent && goIntent == date) {
					price =
						getSmallest(dateData, { withTaxes: true, leg: "in" }) +
						getSmallest(dateData, { withTaxes: true, leg: "out" });
				} else {
					if (goIntent == date) price = goPrice;
					if (goIntent == backIntent) price = goPrice + backPrice;
					if (date === backIntent) {
						price = goPrice + backPrice;
					} else {
						price = goPrice + backPrice;

						if (goIntent == date) price = 0;
					}
				}
			} else {
				price = getSmallest(goData, { leg: "in" }) + getSmallest(goData, { leg: "out" });
			}
		}

		const rank = getPriceRank(price, priceRange);

		// Classnames
		let className = getClassNames(
			{
				first: monthIndex === 0,
				last: monthIndex === monthLength - 1,
				"other-month": monthIndex === null,
				irrelevant: dateIsBeforeGoDate || irrelevant,
				"rank-$": !irrelevant && rank,
				"no-result":
					!irrelevant &&
					!dateIsBeforeGoDate &&
					(!dateData || !dateData[`${currentLeg}_airline_fareTotal`]),
				"range-$": dateIsInRange,
				selected: dateIsSelected,
				disabled
			},
			{ prefix: "big-calendar__day--" }
		);
		className = "big-calendar__day " + className;

		// Events
		const onMouseLeave = () => {
			clearTimeout(this.tooltipTimeout);
			this.setState({ tooltip: false });
		};
		const onMouseEnter = () => {
			if (!irrelevant && !dateIsBeforeGoDate && !disabled && !price) {
				return this.setTooltip(
					"Ainda sem tarifa. Mesmo assim você pode selecionar esse dia e efetuar a pesquisa."
				);
			}
		};
		const onClick = () => dateIsFuture && this.setIntent(date);

		return (
			<div
				ref={node => (this.node = node)}
				className={className}
				style={style}
				onMouseLeave={onMouseLeave}
				onClick={onClick}
				onMouseEnter={onMouseEnter}
			>
				<div>{monthIndex === null ? "" : monthIndex + 1}</div>
				{!irrelevant && dateIsFuture && this.renderPrice(price)}
				{this.renderTooltip()}
			</div>
		);
	}
}

class Calendar extends Component {
	constructor(props) {
		super(props);

		this.state = { animationFinished: false };

		this.renderDay = this.renderDay.bind(this);
		this.renderDays = this.renderDays.bind(this);
		this.getName = this.getName.bind(this);
	}

	renderDay(props) {
		return <Day {...props} />;
	}

	renderDays() {
		const {
			searchIntents,
			month,
			priceRange,
			goIntent,
			backIntent,
			setGoIntent,
			setBackIntent,
			origin,
			destination,
			tripType,
			getPriceCalendar
		} = this.props;
		const numOfWeeks = 6;
		const numOfDays = 7 * numOfWeeks;
		const monthStartsOn = getStartWeekDay(month);
		const monthLength = getMonthLength(month);
		let i = 0; // Iteração durante as linhas de cada calendário
		let j = 0; // Iteração durante dias do mês atual
		let renderedDays = [];

		while (i < numOfDays) {
			let fromPreviousMonth = i < monthStartsOn ? true : false;
			let fromNextMonth = j >= monthLength ? true : false;
			let fromThisMonth = !fromPreviousMonth && !fromNextMonth;

			let props = {
				key: i,
				index: i,
				monthIndex: fromThisMonth ? j : null,
				date: `${month}-${
					(j + 1).toString().length === 1 ? "0" + (j + 1).toString() : (j + 1).toString()
				}`,
				searchIntents,
				monthLength,
				priceRange,
				goIntent,
				backIntent,
				setGoIntent,
				setBackIntent,
				origin,
				destination,
				tripType,
				getPriceCalendar
			};

			renderedDays.push(this.renderDay(props));

			if (!fromPreviousMonth) j++;
			i++;
		}

		return renderedDays;
	}

	getName() {
		const { month: yearMonth } = this.props;
		const month = parseInt(yearMonth.split("-")[1]);

		switch (month) {
			case 1:
				return "Janeiro";
			case 2:
				return "Fevereiro";
			case 3:
				return "Março";
			case 4:
				return "Abril";
			case 5:
				return "Maio";
			case 6:
				return "Junho";
			case 7:
				return "Julho";
			case 8:
				return "Agosto";
			case 9:
				return "Setembro";
			case 10:
				return "Outubro";
			case 11:
				return "Novembro";
			case 12:
				return "Dezembro";
		}
	}

	render() {
		const { month, index } = this.props;
		const slider = winWidth >= 768;

		const calendar = (
			<div className="big-calendar" data-month-index={index} data-year-month={month}>
				<p className="big-calendar__header">{this.getName()}</p>
				<div className="big-calendar__week">
					<span>DOM</span>
					<span>SEG</span>
					<span>TER</span>
					<span>QUA</span>
					<span>QUI</span>
					<span>SEX</span>
					<span>SAB</span>
				</div>
				<div className="big-calendar__day-group">{this.renderDays()}</div>
			</div>
		);

		if (slider) return <div className="swiper-slide">{calendar}</div>;
		else return calendar;
	}
}

export default Calendar;
